import { Actions } from '../constants';

export default function setMediaBreakpoints(payload) {
  return {
    type: Actions.SET_MEDIA_BREAKPOINTS,
    payload,
  };
}
